import { ActionFetch } from '@/store/actionTypes'
import { API } from '@/store/apiPath'
import { AxiosRequest } from '@/store/axiosHelper'
import { MutationStore, MutationView } from '@/store/mutationTypes'
import axios from 'axios'

const request = {
  actions: {
    [ActionFetch.SEO_FACEBOOK.GET_CONFIG]: ({ commit }, $params) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.seoFacebook.getConfig())
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.GET_CONFIG, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.GET_TAG]: ({ commit }, $id) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.seoFacebook.getTag($id))
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.GET_TAG, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.GET_THANKYOU]: ({ commit }, $id) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.seoFacebook.getThankyou($id))
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.GET_THANKYOU, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.UPLOAD]: ({ commit, rootState }, $params) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user = rootState.cmsUser
      let bodyFormData = new FormData()

      bodyFormData.set('uploadFile', $params)

      return axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_API_VERSION}/upload`,
        data: bodyFormData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${user.token}`,
        },
      })
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.UPLOAD, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.SAVE_CONFIG]: (
      { commit, rootState },
      $params,
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user = rootState.cmsUser

      $params.updatedBy = user.id

      return AxiosRequest(API.seoFacebook.updateConfig(), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.SAVE_CONFIG, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.SAVE_TAG]: ({ commit, rootState }, $params) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user = rootState.cmsUser
      const project = $params.project
      $params.pictures = {}
      $params.updatedBy = user.id

      delete $params.project

      return AxiosRequest(API.seoFacebook.saveTag(project), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.SAVE_TAG, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.SEO_FACEBOOK.SAVE_THANKYOU]: (
      { commit, rootState },
      $params,
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user = rootState.cmsUser
      const project = $params.project

      $params.pictures = {}
      $params.updatedBy = user.id

      delete $params.project

      return AxiosRequest(
        API.seoFacebook.saveThankyou(project),
        $params,
        user.token,
      )
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.SEO_FACEBOOK.SAVE_THANKYOU, data.data)
          }

          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },
  },
}

export default request
